import styled from "styled-components";
import {Typography } from "@dev/ee-components";

export const SpacedTypography = styled(Typography)`
    padding-bottom: 16px;
    text-align: center;
`;

export const CenteredTypography = styled(Typography)`
    text-align: center;
`;

export const ButtonContainer = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 32px;
`;